import useGetWelcomeMessage from '../../../../hooks/wizard/useGetWelcomeMessage';

const SplashScreen = () => {
  const {
    subtitleText,
  } = useGetWelcomeMessage();

  return (
    <div className="assistant-v2__loading flex flex-col items-center gap-5 text-center">
      <div className="loader-spinning-white mt-10 self-center" />
      {subtitleText && <span className="text-2xl text-white font-semibold">{subtitleText}</span>}
    </div>
  )
}

export default SplashScreen
